import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class SblockProgramsComponent {

  title = 'Nuestros programas';
  subtitle = 'Itinerarios formativos para cada etapa';
  titlesColor = '#2c3e50';
  secondaryColor = '#7a7a7a';
  linkColor = '#2c3e50';
  buttonText = 'Ver todos los programas';

  programList: Array<{
    id: number;
    name: string;
    image: string;
    price: string;
    priceGlobal: string;
    included: boolean;
  }> = [
    {
      id: 1,
      name: 'Educación Infantil',
      image: 'https://picsum.photos/seed/prog1/400/300',
      price: '120 €',
      priceGlobal: '$130',
      included: false
    },
    {
      id: 2,
      name: 'Educación Primaria',
      image: 'https://picsum.photos/seed/prog2/400/300',
      price: '',
      priceGlobal: '',
      included: true
    },
    {
      id: 3,
      name: 'Educación Secundaria',
      image: 'https://picsum.photos/seed/prog3/400/300',
      price: '180 €',
      priceGlobal: '$195',
      included: false
    }
  ];

}
